export function validatePhoneNumber(number: any): boolean {
  const regex = /^0?\d{10}$/;
  return regex.test(number);
}

export function fixControlledValue<T>(value: T) {
  if (typeof value === "undefined" || value === null) {
    return "";
  }
  return String(value);
}

export function englishToPersianNumbers(value: string): string {
  const englishNumbers = [
    /0/g,
    /1/g,
    /2/g,
    /3/g,
    /4/g,
    /5/g,
    /6/g,
    /7/g,
    /8/g,
    /9/g,
  ];
  const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  let result = value;
  for (let i = 0; i < englishNumbers.length; i++) {
    result = result.replace(englishNumbers[i], persianNumbers[i]);
  }

  return result;
}

export function isHubEnterprise(data: { name?: string } | null | undefined): boolean {
  return Boolean(data?.name?.includes("هاب"));
}

export function hasChefVisibleDescription(
  data: { name?: string; menuDescription?: string } | null | undefined
): boolean {
  if (!data || isHubEnterprise(data)) {
    return false;
  }
  return Boolean(data.menuDescription?.trim());
}

export function persianToEnglishNumbers(value: string): string {
  const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  let result = value;
  for (let i = 0; i < persianNumbers.length; i++) {
    result = result.replace(persianNumbers[i], englishNumbers[i]);
  }

  return result;
}

